/**
 * ApiGest API
 * ApiGest API documentation
 *
 * OpenAPI spec version: 1.0.0
 * Contact: info@eneasys.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApolloDocumentLineDTO } from '../model/apolloDocumentLineDTO';

import { AIG_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ApolloDocumentLineResourceService {

    protected basePath = 'https://api-gest.eneasys.net';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(AIG_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * countApolloDocumentLines
     * 
     * @param aliquotaEquals 
     * @param aliquotaGreaterThan 
     * @param aliquotaGreaterThanOrEqual 
     * @param aliquotaIn 
     * @param aliquotaLessThan 
     * @param aliquotaLessThanOrEqual 
     * @param aliquotaNotEquals 
     * @param aliquotaSpecified 
     * @param apolloDocumentIdEquals 
     * @param apolloDocumentIdGreaterThan 
     * @param apolloDocumentIdGreaterThanOrEqual 
     * @param apolloDocumentIdIn 
     * @param apolloDocumentIdLessThan 
     * @param apolloDocumentIdLessThanOrEqual 
     * @param apolloDocumentIdNotEquals 
     * @param apolloDocumentIdSpecified 
     * @param contrintegpercEquals 
     * @param contrintegpercGreaterThan 
     * @param contrintegpercGreaterThanOrEqual 
     * @param contrintegpercIn 
     * @param contrintegpercLessThan 
     * @param contrintegpercLessThanOrEqual 
     * @param contrintegpercNotEquals 
     * @param contrintegpercSpecified 
     * @param contrintegvalEquals 
     * @param contrintegvalGreaterThan 
     * @param contrintegvalGreaterThanOrEqual 
     * @param contrintegvalIn 
     * @param contrintegvalLessThan 
     * @param contrintegvalLessThanOrEqual 
     * @param contrintegvalNotEquals 
     * @param contrintegvalSpecified 
     * @param descrizioneContains 
     * @param descrizioneDoesNotContain 
     * @param descrizioneEquals 
     * @param descrizioneIn 
     * @param descrizioneNotEquals 
     * @param descrizioneSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param idarticoloEquals 
     * @param idarticoloGreaterThan 
     * @param idarticoloGreaterThanOrEqual 
     * @param idarticoloIn 
     * @param idarticoloLessThan 
     * @param idarticoloLessThanOrEqual 
     * @param idarticoloNotEquals 
     * @param idarticoloSpecified 
     * @param iddettfatturaEquals 
     * @param iddettfatturaGreaterThan 
     * @param iddettfatturaGreaterThanOrEqual 
     * @param iddettfatturaIn 
     * @param iddettfatturaLessThan 
     * @param iddettfatturaLessThanOrEqual 
     * @param iddettfatturaNotEquals 
     * @param iddettfatturaSpecified 
     * @param iddocEquals 
     * @param iddocGreaterThan 
     * @param iddocGreaterThanOrEqual 
     * @param iddocIn 
     * @param iddocLessThan 
     * @param iddocLessThanOrEqual 
     * @param iddocNotEquals 
     * @param iddocSpecified 
     * @param importoEquals 
     * @param importoGreaterThan 
     * @param importoGreaterThanOrEqual 
     * @param importoIn 
     * @param importoLessThan 
     * @param importoLessThanOrEqual 
     * @param importoNotEquals 
     * @param importoSpecified 
     * @param ivaEquals 
     * @param ivaGreaterThan 
     * @param ivaGreaterThanOrEqual 
     * @param ivaIn 
     * @param ivaLessThan 
     * @param ivaLessThanOrEqual 
     * @param ivaNotEquals 
     * @param ivaSpecified 
     * @param prezzoEquals 
     * @param prezzoGreaterThan 
     * @param prezzoGreaterThanOrEqual 
     * @param prezzoIn 
     * @param prezzoLessThan 
     * @param prezzoLessThanOrEqual 
     * @param prezzoNotEquals 
     * @param prezzoSpecified 
     * @param qtaEquals 
     * @param qtaGreaterThan 
     * @param qtaGreaterThanOrEqual 
     * @param qtaIn 
     * @param qtaLessThan 
     * @param qtaLessThanOrEqual 
     * @param qtaNotEquals 
     * @param qtaSpecified 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public countApolloDocumentLinesUsingGET(aliquotaEquals?: number, aliquotaGreaterThan?: number, aliquotaGreaterThanOrEqual?: number, aliquotaIn?: Array<number>, aliquotaLessThan?: number, aliquotaLessThanOrEqual?: number, aliquotaNotEquals?: number, aliquotaSpecified?: boolean, apolloDocumentIdEquals?: number, apolloDocumentIdGreaterThan?: number, apolloDocumentIdGreaterThanOrEqual?: number, apolloDocumentIdIn?: Array<number>, apolloDocumentIdLessThan?: number, apolloDocumentIdLessThanOrEqual?: number, apolloDocumentIdNotEquals?: number, apolloDocumentIdSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, descrizioneContains?: string, descrizioneDoesNotContain?: string, descrizioneEquals?: string, descrizioneIn?: Array<string>, descrizioneNotEquals?: string, descrizioneSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idarticoloEquals?: number, idarticoloGreaterThan?: number, idarticoloGreaterThanOrEqual?: number, idarticoloIn?: Array<number>, idarticoloLessThan?: number, idarticoloLessThanOrEqual?: number, idarticoloNotEquals?: number, idarticoloSpecified?: boolean, iddettfatturaEquals?: number, iddettfatturaGreaterThan?: number, iddettfatturaGreaterThanOrEqual?: number, iddettfatturaIn?: Array<number>, iddettfatturaLessThan?: number, iddettfatturaLessThanOrEqual?: number, iddettfatturaNotEquals?: number, iddettfatturaSpecified?: boolean, iddocEquals?: number, iddocGreaterThan?: number, iddocGreaterThanOrEqual?: number, iddocIn?: Array<number>, iddocLessThan?: number, iddocLessThanOrEqual?: number, iddocNotEquals?: number, iddocSpecified?: boolean, importoEquals?: number, importoGreaterThan?: number, importoGreaterThanOrEqual?: number, importoIn?: Array<number>, importoLessThan?: number, importoLessThanOrEqual?: number, importoNotEquals?: number, importoSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, prezzoEquals?: number, prezzoGreaterThan?: number, prezzoGreaterThanOrEqual?: number, prezzoIn?: Array<number>, prezzoLessThan?: number, prezzoLessThanOrEqual?: number, prezzoNotEquals?: number, prezzoSpecified?: boolean, qtaEquals?: number, qtaGreaterThan?: number, qtaGreaterThanOrEqual?: number, qtaIn?: Array<number>, qtaLessThan?: number, qtaLessThanOrEqual?: number, qtaNotEquals?: number, qtaSpecified?: boolean, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public countApolloDocumentLinesUsingGET(aliquotaEquals?: number, aliquotaGreaterThan?: number, aliquotaGreaterThanOrEqual?: number, aliquotaIn?: Array<number>, aliquotaLessThan?: number, aliquotaLessThanOrEqual?: number, aliquotaNotEquals?: number, aliquotaSpecified?: boolean, apolloDocumentIdEquals?: number, apolloDocumentIdGreaterThan?: number, apolloDocumentIdGreaterThanOrEqual?: number, apolloDocumentIdIn?: Array<number>, apolloDocumentIdLessThan?: number, apolloDocumentIdLessThanOrEqual?: number, apolloDocumentIdNotEquals?: number, apolloDocumentIdSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, descrizioneContains?: string, descrizioneDoesNotContain?: string, descrizioneEquals?: string, descrizioneIn?: Array<string>, descrizioneNotEquals?: string, descrizioneSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idarticoloEquals?: number, idarticoloGreaterThan?: number, idarticoloGreaterThanOrEqual?: number, idarticoloIn?: Array<number>, idarticoloLessThan?: number, idarticoloLessThanOrEqual?: number, idarticoloNotEquals?: number, idarticoloSpecified?: boolean, iddettfatturaEquals?: number, iddettfatturaGreaterThan?: number, iddettfatturaGreaterThanOrEqual?: number, iddettfatturaIn?: Array<number>, iddettfatturaLessThan?: number, iddettfatturaLessThanOrEqual?: number, iddettfatturaNotEquals?: number, iddettfatturaSpecified?: boolean, iddocEquals?: number, iddocGreaterThan?: number, iddocGreaterThanOrEqual?: number, iddocIn?: Array<number>, iddocLessThan?: number, iddocLessThanOrEqual?: number, iddocNotEquals?: number, iddocSpecified?: boolean, importoEquals?: number, importoGreaterThan?: number, importoGreaterThanOrEqual?: number, importoIn?: Array<number>, importoLessThan?: number, importoLessThanOrEqual?: number, importoNotEquals?: number, importoSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, prezzoEquals?: number, prezzoGreaterThan?: number, prezzoGreaterThanOrEqual?: number, prezzoIn?: Array<number>, prezzoLessThan?: number, prezzoLessThanOrEqual?: number, prezzoNotEquals?: number, prezzoSpecified?: boolean, qtaEquals?: number, qtaGreaterThan?: number, qtaGreaterThanOrEqual?: number, qtaIn?: Array<number>, qtaLessThan?: number, qtaLessThanOrEqual?: number, qtaNotEquals?: number, qtaSpecified?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public countApolloDocumentLinesUsingGET(aliquotaEquals?: number, aliquotaGreaterThan?: number, aliquotaGreaterThanOrEqual?: number, aliquotaIn?: Array<number>, aliquotaLessThan?: number, aliquotaLessThanOrEqual?: number, aliquotaNotEquals?: number, aliquotaSpecified?: boolean, apolloDocumentIdEquals?: number, apolloDocumentIdGreaterThan?: number, apolloDocumentIdGreaterThanOrEqual?: number, apolloDocumentIdIn?: Array<number>, apolloDocumentIdLessThan?: number, apolloDocumentIdLessThanOrEqual?: number, apolloDocumentIdNotEquals?: number, apolloDocumentIdSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, descrizioneContains?: string, descrizioneDoesNotContain?: string, descrizioneEquals?: string, descrizioneIn?: Array<string>, descrizioneNotEquals?: string, descrizioneSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idarticoloEquals?: number, idarticoloGreaterThan?: number, idarticoloGreaterThanOrEqual?: number, idarticoloIn?: Array<number>, idarticoloLessThan?: number, idarticoloLessThanOrEqual?: number, idarticoloNotEquals?: number, idarticoloSpecified?: boolean, iddettfatturaEquals?: number, iddettfatturaGreaterThan?: number, iddettfatturaGreaterThanOrEqual?: number, iddettfatturaIn?: Array<number>, iddettfatturaLessThan?: number, iddettfatturaLessThanOrEqual?: number, iddettfatturaNotEquals?: number, iddettfatturaSpecified?: boolean, iddocEquals?: number, iddocGreaterThan?: number, iddocGreaterThanOrEqual?: number, iddocIn?: Array<number>, iddocLessThan?: number, iddocLessThanOrEqual?: number, iddocNotEquals?: number, iddocSpecified?: boolean, importoEquals?: number, importoGreaterThan?: number, importoGreaterThanOrEqual?: number, importoIn?: Array<number>, importoLessThan?: number, importoLessThanOrEqual?: number, importoNotEquals?: number, importoSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, prezzoEquals?: number, prezzoGreaterThan?: number, prezzoGreaterThanOrEqual?: number, prezzoIn?: Array<number>, prezzoLessThan?: number, prezzoLessThanOrEqual?: number, prezzoNotEquals?: number, prezzoSpecified?: boolean, qtaEquals?: number, qtaGreaterThan?: number, qtaGreaterThanOrEqual?: number, qtaIn?: Array<number>, qtaLessThan?: number, qtaLessThanOrEqual?: number, qtaNotEquals?: number, qtaSpecified?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public countApolloDocumentLinesUsingGET(aliquotaEquals?: number, aliquotaGreaterThan?: number, aliquotaGreaterThanOrEqual?: number, aliquotaIn?: Array<number>, aliquotaLessThan?: number, aliquotaLessThanOrEqual?: number, aliquotaNotEquals?: number, aliquotaSpecified?: boolean, apolloDocumentIdEquals?: number, apolloDocumentIdGreaterThan?: number, apolloDocumentIdGreaterThanOrEqual?: number, apolloDocumentIdIn?: Array<number>, apolloDocumentIdLessThan?: number, apolloDocumentIdLessThanOrEqual?: number, apolloDocumentIdNotEquals?: number, apolloDocumentIdSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, descrizioneContains?: string, descrizioneDoesNotContain?: string, descrizioneEquals?: string, descrizioneIn?: Array<string>, descrizioneNotEquals?: string, descrizioneSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idarticoloEquals?: number, idarticoloGreaterThan?: number, idarticoloGreaterThanOrEqual?: number, idarticoloIn?: Array<number>, idarticoloLessThan?: number, idarticoloLessThanOrEqual?: number, idarticoloNotEquals?: number, idarticoloSpecified?: boolean, iddettfatturaEquals?: number, iddettfatturaGreaterThan?: number, iddettfatturaGreaterThanOrEqual?: number, iddettfatturaIn?: Array<number>, iddettfatturaLessThan?: number, iddettfatturaLessThanOrEqual?: number, iddettfatturaNotEquals?: number, iddettfatturaSpecified?: boolean, iddocEquals?: number, iddocGreaterThan?: number, iddocGreaterThanOrEqual?: number, iddocIn?: Array<number>, iddocLessThan?: number, iddocLessThanOrEqual?: number, iddocNotEquals?: number, iddocSpecified?: boolean, importoEquals?: number, importoGreaterThan?: number, importoGreaterThanOrEqual?: number, importoIn?: Array<number>, importoLessThan?: number, importoLessThanOrEqual?: number, importoNotEquals?: number, importoSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, prezzoEquals?: number, prezzoGreaterThan?: number, prezzoGreaterThanOrEqual?: number, prezzoIn?: Array<number>, prezzoLessThan?: number, prezzoLessThanOrEqual?: number, prezzoNotEquals?: number, prezzoSpecified?: boolean, qtaEquals?: number, qtaGreaterThan?: number, qtaGreaterThanOrEqual?: number, qtaIn?: Array<number>, qtaLessThan?: number, qtaLessThanOrEqual?: number, qtaNotEquals?: number, qtaSpecified?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







































































































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aliquotaEquals !== undefined && aliquotaEquals !== null) {
            queryParameters = queryParameters.set('aliquota.equals', <any>aliquotaEquals);
        }
        if (aliquotaGreaterThan !== undefined && aliquotaGreaterThan !== null) {
            queryParameters = queryParameters.set('aliquota.greaterThan', <any>aliquotaGreaterThan);
        }
        if (aliquotaGreaterThanOrEqual !== undefined && aliquotaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('aliquota.greaterThanOrEqual', <any>aliquotaGreaterThanOrEqual);
        }
        if (aliquotaIn) {
            aliquotaIn.forEach((element) => {
                queryParameters = queryParameters.append('aliquota.in', <any>element);
            })
        }
        if (aliquotaLessThan !== undefined && aliquotaLessThan !== null) {
            queryParameters = queryParameters.set('aliquota.lessThan', <any>aliquotaLessThan);
        }
        if (aliquotaLessThanOrEqual !== undefined && aliquotaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('aliquota.lessThanOrEqual', <any>aliquotaLessThanOrEqual);
        }
        if (aliquotaNotEquals !== undefined && aliquotaNotEquals !== null) {
            queryParameters = queryParameters.set('aliquota.notEquals', <any>aliquotaNotEquals);
        }
        if (aliquotaSpecified !== undefined && aliquotaSpecified !== null) {
            queryParameters = queryParameters.set('aliquota.specified', <any>aliquotaSpecified);
        }
        if (apolloDocumentIdEquals !== undefined && apolloDocumentIdEquals !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.equals', <any>apolloDocumentIdEquals);
        }
        if (apolloDocumentIdGreaterThan !== undefined && apolloDocumentIdGreaterThan !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.greaterThan', <any>apolloDocumentIdGreaterThan);
        }
        if (apolloDocumentIdGreaterThanOrEqual !== undefined && apolloDocumentIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.greaterThanOrEqual', <any>apolloDocumentIdGreaterThanOrEqual);
        }
        if (apolloDocumentIdIn) {
            apolloDocumentIdIn.forEach((element) => {
                queryParameters = queryParameters.append('apolloDocumentId.in', <any>element);
            })
        }
        if (apolloDocumentIdLessThan !== undefined && apolloDocumentIdLessThan !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.lessThan', <any>apolloDocumentIdLessThan);
        }
        if (apolloDocumentIdLessThanOrEqual !== undefined && apolloDocumentIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.lessThanOrEqual', <any>apolloDocumentIdLessThanOrEqual);
        }
        if (apolloDocumentIdNotEquals !== undefined && apolloDocumentIdNotEquals !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.notEquals', <any>apolloDocumentIdNotEquals);
        }
        if (apolloDocumentIdSpecified !== undefined && apolloDocumentIdSpecified !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.specified', <any>apolloDocumentIdSpecified);
        }
        if (contrintegpercEquals !== undefined && contrintegpercEquals !== null) {
            queryParameters = queryParameters.set('contrintegperc.equals', <any>contrintegpercEquals);
        }
        if (contrintegpercGreaterThan !== undefined && contrintegpercGreaterThan !== null) {
            queryParameters = queryParameters.set('contrintegperc.greaterThan', <any>contrintegpercGreaterThan);
        }
        if (contrintegpercGreaterThanOrEqual !== undefined && contrintegpercGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegperc.greaterThanOrEqual', <any>contrintegpercGreaterThanOrEqual);
        }
        if (contrintegpercIn) {
            contrintegpercIn.forEach((element) => {
                queryParameters = queryParameters.append('contrintegperc.in', <any>element);
            })
        }
        if (contrintegpercLessThan !== undefined && contrintegpercLessThan !== null) {
            queryParameters = queryParameters.set('contrintegperc.lessThan', <any>contrintegpercLessThan);
        }
        if (contrintegpercLessThanOrEqual !== undefined && contrintegpercLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegperc.lessThanOrEqual', <any>contrintegpercLessThanOrEqual);
        }
        if (contrintegpercNotEquals !== undefined && contrintegpercNotEquals !== null) {
            queryParameters = queryParameters.set('contrintegperc.notEquals', <any>contrintegpercNotEquals);
        }
        if (contrintegpercSpecified !== undefined && contrintegpercSpecified !== null) {
            queryParameters = queryParameters.set('contrintegperc.specified', <any>contrintegpercSpecified);
        }
        if (contrintegvalEquals !== undefined && contrintegvalEquals !== null) {
            queryParameters = queryParameters.set('contrintegval.equals', <any>contrintegvalEquals);
        }
        if (contrintegvalGreaterThan !== undefined && contrintegvalGreaterThan !== null) {
            queryParameters = queryParameters.set('contrintegval.greaterThan', <any>contrintegvalGreaterThan);
        }
        if (contrintegvalGreaterThanOrEqual !== undefined && contrintegvalGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegval.greaterThanOrEqual', <any>contrintegvalGreaterThanOrEqual);
        }
        if (contrintegvalIn) {
            contrintegvalIn.forEach((element) => {
                queryParameters = queryParameters.append('contrintegval.in', <any>element);
            })
        }
        if (contrintegvalLessThan !== undefined && contrintegvalLessThan !== null) {
            queryParameters = queryParameters.set('contrintegval.lessThan', <any>contrintegvalLessThan);
        }
        if (contrintegvalLessThanOrEqual !== undefined && contrintegvalLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegval.lessThanOrEqual', <any>contrintegvalLessThanOrEqual);
        }
        if (contrintegvalNotEquals !== undefined && contrintegvalNotEquals !== null) {
            queryParameters = queryParameters.set('contrintegval.notEquals', <any>contrintegvalNotEquals);
        }
        if (contrintegvalSpecified !== undefined && contrintegvalSpecified !== null) {
            queryParameters = queryParameters.set('contrintegval.specified', <any>contrintegvalSpecified);
        }
        if (descrizioneContains !== undefined && descrizioneContains !== null) {
            queryParameters = queryParameters.set('descrizione.contains', <any>descrizioneContains);
        }
        if (descrizioneDoesNotContain !== undefined && descrizioneDoesNotContain !== null) {
            queryParameters = queryParameters.set('descrizione.doesNotContain', <any>descrizioneDoesNotContain);
        }
        if (descrizioneEquals !== undefined && descrizioneEquals !== null) {
            queryParameters = queryParameters.set('descrizione.equals', <any>descrizioneEquals);
        }
        if (descrizioneIn) {
            descrizioneIn.forEach((element) => {
                queryParameters = queryParameters.append('descrizione.in', <any>element);
            })
        }
        if (descrizioneNotEquals !== undefined && descrizioneNotEquals !== null) {
            queryParameters = queryParameters.set('descrizione.notEquals', <any>descrizioneNotEquals);
        }
        if (descrizioneSpecified !== undefined && descrizioneSpecified !== null) {
            queryParameters = queryParameters.set('descrizione.specified', <any>descrizioneSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (idarticoloEquals !== undefined && idarticoloEquals !== null) {
            queryParameters = queryParameters.set('idarticolo.equals', <any>idarticoloEquals);
        }
        if (idarticoloGreaterThan !== undefined && idarticoloGreaterThan !== null) {
            queryParameters = queryParameters.set('idarticolo.greaterThan', <any>idarticoloGreaterThan);
        }
        if (idarticoloGreaterThanOrEqual !== undefined && idarticoloGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('idarticolo.greaterThanOrEqual', <any>idarticoloGreaterThanOrEqual);
        }
        if (idarticoloIn) {
            idarticoloIn.forEach((element) => {
                queryParameters = queryParameters.append('idarticolo.in', <any>element);
            })
        }
        if (idarticoloLessThan !== undefined && idarticoloLessThan !== null) {
            queryParameters = queryParameters.set('idarticolo.lessThan', <any>idarticoloLessThan);
        }
        if (idarticoloLessThanOrEqual !== undefined && idarticoloLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('idarticolo.lessThanOrEqual', <any>idarticoloLessThanOrEqual);
        }
        if (idarticoloNotEquals !== undefined && idarticoloNotEquals !== null) {
            queryParameters = queryParameters.set('idarticolo.notEquals', <any>idarticoloNotEquals);
        }
        if (idarticoloSpecified !== undefined && idarticoloSpecified !== null) {
            queryParameters = queryParameters.set('idarticolo.specified', <any>idarticoloSpecified);
        }
        if (iddettfatturaEquals !== undefined && iddettfatturaEquals !== null) {
            queryParameters = queryParameters.set('iddettfattura.equals', <any>iddettfatturaEquals);
        }
        if (iddettfatturaGreaterThan !== undefined && iddettfatturaGreaterThan !== null) {
            queryParameters = queryParameters.set('iddettfattura.greaterThan', <any>iddettfatturaGreaterThan);
        }
        if (iddettfatturaGreaterThanOrEqual !== undefined && iddettfatturaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('iddettfattura.greaterThanOrEqual', <any>iddettfatturaGreaterThanOrEqual);
        }
        if (iddettfatturaIn) {
            iddettfatturaIn.forEach((element) => {
                queryParameters = queryParameters.append('iddettfattura.in', <any>element);
            })
        }
        if (iddettfatturaLessThan !== undefined && iddettfatturaLessThan !== null) {
            queryParameters = queryParameters.set('iddettfattura.lessThan', <any>iddettfatturaLessThan);
        }
        if (iddettfatturaLessThanOrEqual !== undefined && iddettfatturaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('iddettfattura.lessThanOrEqual', <any>iddettfatturaLessThanOrEqual);
        }
        if (iddettfatturaNotEquals !== undefined && iddettfatturaNotEquals !== null) {
            queryParameters = queryParameters.set('iddettfattura.notEquals', <any>iddettfatturaNotEquals);
        }
        if (iddettfatturaSpecified !== undefined && iddettfatturaSpecified !== null) {
            queryParameters = queryParameters.set('iddettfattura.specified', <any>iddettfatturaSpecified);
        }
        if (iddocEquals !== undefined && iddocEquals !== null) {
            queryParameters = queryParameters.set('iddoc.equals', <any>iddocEquals);
        }
        if (iddocGreaterThan !== undefined && iddocGreaterThan !== null) {
            queryParameters = queryParameters.set('iddoc.greaterThan', <any>iddocGreaterThan);
        }
        if (iddocGreaterThanOrEqual !== undefined && iddocGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('iddoc.greaterThanOrEqual', <any>iddocGreaterThanOrEqual);
        }
        if (iddocIn) {
            iddocIn.forEach((element) => {
                queryParameters = queryParameters.append('iddoc.in', <any>element);
            })
        }
        if (iddocLessThan !== undefined && iddocLessThan !== null) {
            queryParameters = queryParameters.set('iddoc.lessThan', <any>iddocLessThan);
        }
        if (iddocLessThanOrEqual !== undefined && iddocLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('iddoc.lessThanOrEqual', <any>iddocLessThanOrEqual);
        }
        if (iddocNotEquals !== undefined && iddocNotEquals !== null) {
            queryParameters = queryParameters.set('iddoc.notEquals', <any>iddocNotEquals);
        }
        if (iddocSpecified !== undefined && iddocSpecified !== null) {
            queryParameters = queryParameters.set('iddoc.specified', <any>iddocSpecified);
        }
        if (importoEquals !== undefined && importoEquals !== null) {
            queryParameters = queryParameters.set('importo.equals', <any>importoEquals);
        }
        if (importoGreaterThan !== undefined && importoGreaterThan !== null) {
            queryParameters = queryParameters.set('importo.greaterThan', <any>importoGreaterThan);
        }
        if (importoGreaterThanOrEqual !== undefined && importoGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('importo.greaterThanOrEqual', <any>importoGreaterThanOrEqual);
        }
        if (importoIn) {
            importoIn.forEach((element) => {
                queryParameters = queryParameters.append('importo.in', <any>element);
            })
        }
        if (importoLessThan !== undefined && importoLessThan !== null) {
            queryParameters = queryParameters.set('importo.lessThan', <any>importoLessThan);
        }
        if (importoLessThanOrEqual !== undefined && importoLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('importo.lessThanOrEqual', <any>importoLessThanOrEqual);
        }
        if (importoNotEquals !== undefined && importoNotEquals !== null) {
            queryParameters = queryParameters.set('importo.notEquals', <any>importoNotEquals);
        }
        if (importoSpecified !== undefined && importoSpecified !== null) {
            queryParameters = queryParameters.set('importo.specified', <any>importoSpecified);
        }
        if (ivaEquals !== undefined && ivaEquals !== null) {
            queryParameters = queryParameters.set('iva.equals', <any>ivaEquals);
        }
        if (ivaGreaterThan !== undefined && ivaGreaterThan !== null) {
            queryParameters = queryParameters.set('iva.greaterThan', <any>ivaGreaterThan);
        }
        if (ivaGreaterThanOrEqual !== undefined && ivaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('iva.greaterThanOrEqual', <any>ivaGreaterThanOrEqual);
        }
        if (ivaIn) {
            ivaIn.forEach((element) => {
                queryParameters = queryParameters.append('iva.in', <any>element);
            })
        }
        if (ivaLessThan !== undefined && ivaLessThan !== null) {
            queryParameters = queryParameters.set('iva.lessThan', <any>ivaLessThan);
        }
        if (ivaLessThanOrEqual !== undefined && ivaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('iva.lessThanOrEqual', <any>ivaLessThanOrEqual);
        }
        if (ivaNotEquals !== undefined && ivaNotEquals !== null) {
            queryParameters = queryParameters.set('iva.notEquals', <any>ivaNotEquals);
        }
        if (ivaSpecified !== undefined && ivaSpecified !== null) {
            queryParameters = queryParameters.set('iva.specified', <any>ivaSpecified);
        }
        if (prezzoEquals !== undefined && prezzoEquals !== null) {
            queryParameters = queryParameters.set('prezzo.equals', <any>prezzoEquals);
        }
        if (prezzoGreaterThan !== undefined && prezzoGreaterThan !== null) {
            queryParameters = queryParameters.set('prezzo.greaterThan', <any>prezzoGreaterThan);
        }
        if (prezzoGreaterThanOrEqual !== undefined && prezzoGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('prezzo.greaterThanOrEqual', <any>prezzoGreaterThanOrEqual);
        }
        if (prezzoIn) {
            prezzoIn.forEach((element) => {
                queryParameters = queryParameters.append('prezzo.in', <any>element);
            })
        }
        if (prezzoLessThan !== undefined && prezzoLessThan !== null) {
            queryParameters = queryParameters.set('prezzo.lessThan', <any>prezzoLessThan);
        }
        if (prezzoLessThanOrEqual !== undefined && prezzoLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('prezzo.lessThanOrEqual', <any>prezzoLessThanOrEqual);
        }
        if (prezzoNotEquals !== undefined && prezzoNotEquals !== null) {
            queryParameters = queryParameters.set('prezzo.notEquals', <any>prezzoNotEquals);
        }
        if (prezzoSpecified !== undefined && prezzoSpecified !== null) {
            queryParameters = queryParameters.set('prezzo.specified', <any>prezzoSpecified);
        }
        if (qtaEquals !== undefined && qtaEquals !== null) {
            queryParameters = queryParameters.set('qta.equals', <any>qtaEquals);
        }
        if (qtaGreaterThan !== undefined && qtaGreaterThan !== null) {
            queryParameters = queryParameters.set('qta.greaterThan', <any>qtaGreaterThan);
        }
        if (qtaGreaterThanOrEqual !== undefined && qtaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('qta.greaterThanOrEqual', <any>qtaGreaterThanOrEqual);
        }
        if (qtaIn) {
            qtaIn.forEach((element) => {
                queryParameters = queryParameters.append('qta.in', <any>element);
            })
        }
        if (qtaLessThan !== undefined && qtaLessThan !== null) {
            queryParameters = queryParameters.set('qta.lessThan', <any>qtaLessThan);
        }
        if (qtaLessThanOrEqual !== undefined && qtaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('qta.lessThanOrEqual', <any>qtaLessThanOrEqual);
        }
        if (qtaNotEquals !== undefined && qtaNotEquals !== null) {
            queryParameters = queryParameters.set('qta.notEquals', <any>qtaNotEquals);
        }
        if (qtaSpecified !== undefined && qtaSpecified !== null) {
            queryParameters = queryParameters.set('qta.specified', <any>qtaSpecified);
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<number>('get',`${this.basePath}/api/apollo-document-lines/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * createApolloDocumentLine
     * 
     * @param body apolloDocumentLineDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createApolloDocumentLineUsingPOST(body: ApolloDocumentLineDTO, observe?: 'body', reportProgress?: boolean): Observable<ApolloDocumentLineDTO>;
    public createApolloDocumentLineUsingPOST(body: ApolloDocumentLineDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApolloDocumentLineDTO>>;
    public createApolloDocumentLineUsingPOST(body: ApolloDocumentLineDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApolloDocumentLineDTO>>;
    public createApolloDocumentLineUsingPOST(body: ApolloDocumentLineDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createApolloDocumentLineUsingPOST.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ApolloDocumentLineDTO>('post',`${this.basePath}/api/apollo-document-lines`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteApolloDocumentLine
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteApolloDocumentLineUsingDELETE(id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteApolloDocumentLineUsingDELETE(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteApolloDocumentLineUsingDELETE(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteApolloDocumentLineUsingDELETE(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteApolloDocumentLineUsingDELETE.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/apollo-document-lines/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getAllApolloDocumentLines
     * 
     * @param aliquotaEquals 
     * @param aliquotaGreaterThan 
     * @param aliquotaGreaterThanOrEqual 
     * @param aliquotaIn 
     * @param aliquotaLessThan 
     * @param aliquotaLessThanOrEqual 
     * @param aliquotaNotEquals 
     * @param aliquotaSpecified 
     * @param apolloDocumentIdEquals 
     * @param apolloDocumentIdGreaterThan 
     * @param apolloDocumentIdGreaterThanOrEqual 
     * @param apolloDocumentIdIn 
     * @param apolloDocumentIdLessThan 
     * @param apolloDocumentIdLessThanOrEqual 
     * @param apolloDocumentIdNotEquals 
     * @param apolloDocumentIdSpecified 
     * @param contrintegpercEquals 
     * @param contrintegpercGreaterThan 
     * @param contrintegpercGreaterThanOrEqual 
     * @param contrintegpercIn 
     * @param contrintegpercLessThan 
     * @param contrintegpercLessThanOrEqual 
     * @param contrintegpercNotEquals 
     * @param contrintegpercSpecified 
     * @param contrintegvalEquals 
     * @param contrintegvalGreaterThan 
     * @param contrintegvalGreaterThanOrEqual 
     * @param contrintegvalIn 
     * @param contrintegvalLessThan 
     * @param contrintegvalLessThanOrEqual 
     * @param contrintegvalNotEquals 
     * @param contrintegvalSpecified 
     * @param descrizioneContains 
     * @param descrizioneDoesNotContain 
     * @param descrizioneEquals 
     * @param descrizioneIn 
     * @param descrizioneNotEquals 
     * @param descrizioneSpecified 
     * @param idEquals 
     * @param idGreaterThan 
     * @param idGreaterThanOrEqual 
     * @param idIn 
     * @param idLessThan 
     * @param idLessThanOrEqual 
     * @param idNotEquals 
     * @param idSpecified 
     * @param idarticoloEquals 
     * @param idarticoloGreaterThan 
     * @param idarticoloGreaterThanOrEqual 
     * @param idarticoloIn 
     * @param idarticoloLessThan 
     * @param idarticoloLessThanOrEqual 
     * @param idarticoloNotEquals 
     * @param idarticoloSpecified 
     * @param iddettfatturaEquals 
     * @param iddettfatturaGreaterThan 
     * @param iddettfatturaGreaterThanOrEqual 
     * @param iddettfatturaIn 
     * @param iddettfatturaLessThan 
     * @param iddettfatturaLessThanOrEqual 
     * @param iddettfatturaNotEquals 
     * @param iddettfatturaSpecified 
     * @param iddocEquals 
     * @param iddocGreaterThan 
     * @param iddocGreaterThanOrEqual 
     * @param iddocIn 
     * @param iddocLessThan 
     * @param iddocLessThanOrEqual 
     * @param iddocNotEquals 
     * @param iddocSpecified 
     * @param importoEquals 
     * @param importoGreaterThan 
     * @param importoGreaterThanOrEqual 
     * @param importoIn 
     * @param importoLessThan 
     * @param importoLessThanOrEqual 
     * @param importoNotEquals 
     * @param importoSpecified 
     * @param ivaEquals 
     * @param ivaGreaterThan 
     * @param ivaGreaterThanOrEqual 
     * @param ivaIn 
     * @param ivaLessThan 
     * @param ivaLessThanOrEqual 
     * @param ivaNotEquals 
     * @param ivaSpecified 
     * @param page Page number of the requested page
     * @param prezzoEquals 
     * @param prezzoGreaterThan 
     * @param prezzoGreaterThanOrEqual 
     * @param prezzoIn 
     * @param prezzoLessThan 
     * @param prezzoLessThanOrEqual 
     * @param prezzoNotEquals 
     * @param prezzoSpecified 
     * @param qtaEquals 
     * @param qtaGreaterThan 
     * @param qtaGreaterThanOrEqual 
     * @param qtaIn 
     * @param qtaLessThan 
     * @param qtaLessThanOrEqual 
     * @param qtaNotEquals 
     * @param qtaSpecified 
     * @param size Size of a page
     * @param sort Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllApolloDocumentLinesUsingGET(aliquotaEquals?: number, aliquotaGreaterThan?: number, aliquotaGreaterThanOrEqual?: number, aliquotaIn?: Array<number>, aliquotaLessThan?: number, aliquotaLessThanOrEqual?: number, aliquotaNotEquals?: number, aliquotaSpecified?: boolean, apolloDocumentIdEquals?: number, apolloDocumentIdGreaterThan?: number, apolloDocumentIdGreaterThanOrEqual?: number, apolloDocumentIdIn?: Array<number>, apolloDocumentIdLessThan?: number, apolloDocumentIdLessThanOrEqual?: number, apolloDocumentIdNotEquals?: number, apolloDocumentIdSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, descrizioneContains?: string, descrizioneDoesNotContain?: string, descrizioneEquals?: string, descrizioneIn?: Array<string>, descrizioneNotEquals?: string, descrizioneSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idarticoloEquals?: number, idarticoloGreaterThan?: number, idarticoloGreaterThanOrEqual?: number, idarticoloIn?: Array<number>, idarticoloLessThan?: number, idarticoloLessThanOrEqual?: number, idarticoloNotEquals?: number, idarticoloSpecified?: boolean, iddettfatturaEquals?: number, iddettfatturaGreaterThan?: number, iddettfatturaGreaterThanOrEqual?: number, iddettfatturaIn?: Array<number>, iddettfatturaLessThan?: number, iddettfatturaLessThanOrEqual?: number, iddettfatturaNotEquals?: number, iddettfatturaSpecified?: boolean, iddocEquals?: number, iddocGreaterThan?: number, iddocGreaterThanOrEqual?: number, iddocIn?: Array<number>, iddocLessThan?: number, iddocLessThanOrEqual?: number, iddocNotEquals?: number, iddocSpecified?: boolean, importoEquals?: number, importoGreaterThan?: number, importoGreaterThanOrEqual?: number, importoIn?: Array<number>, importoLessThan?: number, importoLessThanOrEqual?: number, importoNotEquals?: number, importoSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, page?: number, prezzoEquals?: number, prezzoGreaterThan?: number, prezzoGreaterThanOrEqual?: number, prezzoIn?: Array<number>, prezzoLessThan?: number, prezzoLessThanOrEqual?: number, prezzoNotEquals?: number, prezzoSpecified?: boolean, qtaEquals?: number, qtaGreaterThan?: number, qtaGreaterThanOrEqual?: number, qtaIn?: Array<number>, qtaLessThan?: number, qtaLessThanOrEqual?: number, qtaNotEquals?: number, qtaSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<Array<ApolloDocumentLineDTO>>;
    public getAllApolloDocumentLinesUsingGET(aliquotaEquals?: number, aliquotaGreaterThan?: number, aliquotaGreaterThanOrEqual?: number, aliquotaIn?: Array<number>, aliquotaLessThan?: number, aliquotaLessThanOrEqual?: number, aliquotaNotEquals?: number, aliquotaSpecified?: boolean, apolloDocumentIdEquals?: number, apolloDocumentIdGreaterThan?: number, apolloDocumentIdGreaterThanOrEqual?: number, apolloDocumentIdIn?: Array<number>, apolloDocumentIdLessThan?: number, apolloDocumentIdLessThanOrEqual?: number, apolloDocumentIdNotEquals?: number, apolloDocumentIdSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, descrizioneContains?: string, descrizioneDoesNotContain?: string, descrizioneEquals?: string, descrizioneIn?: Array<string>, descrizioneNotEquals?: string, descrizioneSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idarticoloEquals?: number, idarticoloGreaterThan?: number, idarticoloGreaterThanOrEqual?: number, idarticoloIn?: Array<number>, idarticoloLessThan?: number, idarticoloLessThanOrEqual?: number, idarticoloNotEquals?: number, idarticoloSpecified?: boolean, iddettfatturaEquals?: number, iddettfatturaGreaterThan?: number, iddettfatturaGreaterThanOrEqual?: number, iddettfatturaIn?: Array<number>, iddettfatturaLessThan?: number, iddettfatturaLessThanOrEqual?: number, iddettfatturaNotEquals?: number, iddettfatturaSpecified?: boolean, iddocEquals?: number, iddocGreaterThan?: number, iddocGreaterThanOrEqual?: number, iddocIn?: Array<number>, iddocLessThan?: number, iddocLessThanOrEqual?: number, iddocNotEquals?: number, iddocSpecified?: boolean, importoEquals?: number, importoGreaterThan?: number, importoGreaterThanOrEqual?: number, importoIn?: Array<number>, importoLessThan?: number, importoLessThanOrEqual?: number, importoNotEquals?: number, importoSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, page?: number, prezzoEquals?: number, prezzoGreaterThan?: number, prezzoGreaterThanOrEqual?: number, prezzoIn?: Array<number>, prezzoLessThan?: number, prezzoLessThanOrEqual?: number, prezzoNotEquals?: number, prezzoSpecified?: boolean, qtaEquals?: number, qtaGreaterThan?: number, qtaGreaterThanOrEqual?: number, qtaIn?: Array<number>, qtaLessThan?: number, qtaLessThanOrEqual?: number, qtaNotEquals?: number, qtaSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ApolloDocumentLineDTO>>>;
    public getAllApolloDocumentLinesUsingGET(aliquotaEquals?: number, aliquotaGreaterThan?: number, aliquotaGreaterThanOrEqual?: number, aliquotaIn?: Array<number>, aliquotaLessThan?: number, aliquotaLessThanOrEqual?: number, aliquotaNotEquals?: number, aliquotaSpecified?: boolean, apolloDocumentIdEquals?: number, apolloDocumentIdGreaterThan?: number, apolloDocumentIdGreaterThanOrEqual?: number, apolloDocumentIdIn?: Array<number>, apolloDocumentIdLessThan?: number, apolloDocumentIdLessThanOrEqual?: number, apolloDocumentIdNotEquals?: number, apolloDocumentIdSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, descrizioneContains?: string, descrizioneDoesNotContain?: string, descrizioneEquals?: string, descrizioneIn?: Array<string>, descrizioneNotEquals?: string, descrizioneSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idarticoloEquals?: number, idarticoloGreaterThan?: number, idarticoloGreaterThanOrEqual?: number, idarticoloIn?: Array<number>, idarticoloLessThan?: number, idarticoloLessThanOrEqual?: number, idarticoloNotEquals?: number, idarticoloSpecified?: boolean, iddettfatturaEquals?: number, iddettfatturaGreaterThan?: number, iddettfatturaGreaterThanOrEqual?: number, iddettfatturaIn?: Array<number>, iddettfatturaLessThan?: number, iddettfatturaLessThanOrEqual?: number, iddettfatturaNotEquals?: number, iddettfatturaSpecified?: boolean, iddocEquals?: number, iddocGreaterThan?: number, iddocGreaterThanOrEqual?: number, iddocIn?: Array<number>, iddocLessThan?: number, iddocLessThanOrEqual?: number, iddocNotEquals?: number, iddocSpecified?: boolean, importoEquals?: number, importoGreaterThan?: number, importoGreaterThanOrEqual?: number, importoIn?: Array<number>, importoLessThan?: number, importoLessThanOrEqual?: number, importoNotEquals?: number, importoSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, page?: number, prezzoEquals?: number, prezzoGreaterThan?: number, prezzoGreaterThanOrEqual?: number, prezzoIn?: Array<number>, prezzoLessThan?: number, prezzoLessThanOrEqual?: number, prezzoNotEquals?: number, prezzoSpecified?: boolean, qtaEquals?: number, qtaGreaterThan?: number, qtaGreaterThanOrEqual?: number, qtaIn?: Array<number>, qtaLessThan?: number, qtaLessThanOrEqual?: number, qtaNotEquals?: number, qtaSpecified?: boolean, size?: number, sort?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ApolloDocumentLineDTO>>>;
    public getAllApolloDocumentLinesUsingGET(aliquotaEquals?: number, aliquotaGreaterThan?: number, aliquotaGreaterThanOrEqual?: number, aliquotaIn?: Array<number>, aliquotaLessThan?: number, aliquotaLessThanOrEqual?: number, aliquotaNotEquals?: number, aliquotaSpecified?: boolean, apolloDocumentIdEquals?: number, apolloDocumentIdGreaterThan?: number, apolloDocumentIdGreaterThanOrEqual?: number, apolloDocumentIdIn?: Array<number>, apolloDocumentIdLessThan?: number, apolloDocumentIdLessThanOrEqual?: number, apolloDocumentIdNotEquals?: number, apolloDocumentIdSpecified?: boolean, contrintegpercEquals?: number, contrintegpercGreaterThan?: number, contrintegpercGreaterThanOrEqual?: number, contrintegpercIn?: Array<number>, contrintegpercLessThan?: number, contrintegpercLessThanOrEqual?: number, contrintegpercNotEquals?: number, contrintegpercSpecified?: boolean, contrintegvalEquals?: number, contrintegvalGreaterThan?: number, contrintegvalGreaterThanOrEqual?: number, contrintegvalIn?: Array<number>, contrintegvalLessThan?: number, contrintegvalLessThanOrEqual?: number, contrintegvalNotEquals?: number, contrintegvalSpecified?: boolean, descrizioneContains?: string, descrizioneDoesNotContain?: string, descrizioneEquals?: string, descrizioneIn?: Array<string>, descrizioneNotEquals?: string, descrizioneSpecified?: boolean, idEquals?: number, idGreaterThan?: number, idGreaterThanOrEqual?: number, idIn?: Array<number>, idLessThan?: number, idLessThanOrEqual?: number, idNotEquals?: number, idSpecified?: boolean, idarticoloEquals?: number, idarticoloGreaterThan?: number, idarticoloGreaterThanOrEqual?: number, idarticoloIn?: Array<number>, idarticoloLessThan?: number, idarticoloLessThanOrEqual?: number, idarticoloNotEquals?: number, idarticoloSpecified?: boolean, iddettfatturaEquals?: number, iddettfatturaGreaterThan?: number, iddettfatturaGreaterThanOrEqual?: number, iddettfatturaIn?: Array<number>, iddettfatturaLessThan?: number, iddettfatturaLessThanOrEqual?: number, iddettfatturaNotEquals?: number, iddettfatturaSpecified?: boolean, iddocEquals?: number, iddocGreaterThan?: number, iddocGreaterThanOrEqual?: number, iddocIn?: Array<number>, iddocLessThan?: number, iddocLessThanOrEqual?: number, iddocNotEquals?: number, iddocSpecified?: boolean, importoEquals?: number, importoGreaterThan?: number, importoGreaterThanOrEqual?: number, importoIn?: Array<number>, importoLessThan?: number, importoLessThanOrEqual?: number, importoNotEquals?: number, importoSpecified?: boolean, ivaEquals?: number, ivaGreaterThan?: number, ivaGreaterThanOrEqual?: number, ivaIn?: Array<number>, ivaLessThan?: number, ivaLessThanOrEqual?: number, ivaNotEquals?: number, ivaSpecified?: boolean, page?: number, prezzoEquals?: number, prezzoGreaterThan?: number, prezzoGreaterThanOrEqual?: number, prezzoIn?: Array<number>, prezzoLessThan?: number, prezzoLessThanOrEqual?: number, prezzoNotEquals?: number, prezzoSpecified?: boolean, qtaEquals?: number, qtaGreaterThan?: number, qtaGreaterThanOrEqual?: number, qtaIn?: Array<number>, qtaLessThan?: number, qtaLessThanOrEqual?: number, qtaNotEquals?: number, qtaSpecified?: boolean, size?: number, sort?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










































































































        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (aliquotaEquals !== undefined && aliquotaEquals !== null) {
            queryParameters = queryParameters.set('aliquota.equals', <any>aliquotaEquals);
        }
        if (aliquotaGreaterThan !== undefined && aliquotaGreaterThan !== null) {
            queryParameters = queryParameters.set('aliquota.greaterThan', <any>aliquotaGreaterThan);
        }
        if (aliquotaGreaterThanOrEqual !== undefined && aliquotaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('aliquota.greaterThanOrEqual', <any>aliquotaGreaterThanOrEqual);
        }
        if (aliquotaIn) {
            aliquotaIn.forEach((element) => {
                queryParameters = queryParameters.append('aliquota.in', <any>element);
            })
        }
        if (aliquotaLessThan !== undefined && aliquotaLessThan !== null) {
            queryParameters = queryParameters.set('aliquota.lessThan', <any>aliquotaLessThan);
        }
        if (aliquotaLessThanOrEqual !== undefined && aliquotaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('aliquota.lessThanOrEqual', <any>aliquotaLessThanOrEqual);
        }
        if (aliquotaNotEquals !== undefined && aliquotaNotEquals !== null) {
            queryParameters = queryParameters.set('aliquota.notEquals', <any>aliquotaNotEquals);
        }
        if (aliquotaSpecified !== undefined && aliquotaSpecified !== null) {
            queryParameters = queryParameters.set('aliquota.specified', <any>aliquotaSpecified);
        }
        if (apolloDocumentIdEquals !== undefined && apolloDocumentIdEquals !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.equals', <any>apolloDocumentIdEquals);
        }
        if (apolloDocumentIdGreaterThan !== undefined && apolloDocumentIdGreaterThan !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.greaterThan', <any>apolloDocumentIdGreaterThan);
        }
        if (apolloDocumentIdGreaterThanOrEqual !== undefined && apolloDocumentIdGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.greaterThanOrEqual', <any>apolloDocumentIdGreaterThanOrEqual);
        }
        if (apolloDocumentIdIn) {
            apolloDocumentIdIn.forEach((element) => {
                queryParameters = queryParameters.append('apolloDocumentId.in', <any>element);
            })
        }
        if (apolloDocumentIdLessThan !== undefined && apolloDocumentIdLessThan !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.lessThan', <any>apolloDocumentIdLessThan);
        }
        if (apolloDocumentIdLessThanOrEqual !== undefined && apolloDocumentIdLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.lessThanOrEqual', <any>apolloDocumentIdLessThanOrEqual);
        }
        if (apolloDocumentIdNotEquals !== undefined && apolloDocumentIdNotEquals !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.notEquals', <any>apolloDocumentIdNotEquals);
        }
        if (apolloDocumentIdSpecified !== undefined && apolloDocumentIdSpecified !== null) {
            queryParameters = queryParameters.set('apolloDocumentId.specified', <any>apolloDocumentIdSpecified);
        }
        if (contrintegpercEquals !== undefined && contrintegpercEquals !== null) {
            queryParameters = queryParameters.set('contrintegperc.equals', <any>contrintegpercEquals);
        }
        if (contrintegpercGreaterThan !== undefined && contrintegpercGreaterThan !== null) {
            queryParameters = queryParameters.set('contrintegperc.greaterThan', <any>contrintegpercGreaterThan);
        }
        if (contrintegpercGreaterThanOrEqual !== undefined && contrintegpercGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegperc.greaterThanOrEqual', <any>contrintegpercGreaterThanOrEqual);
        }
        if (contrintegpercIn) {
            contrintegpercIn.forEach((element) => {
                queryParameters = queryParameters.append('contrintegperc.in', <any>element);
            })
        }
        if (contrintegpercLessThan !== undefined && contrintegpercLessThan !== null) {
            queryParameters = queryParameters.set('contrintegperc.lessThan', <any>contrintegpercLessThan);
        }
        if (contrintegpercLessThanOrEqual !== undefined && contrintegpercLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegperc.lessThanOrEqual', <any>contrintegpercLessThanOrEqual);
        }
        if (contrintegpercNotEquals !== undefined && contrintegpercNotEquals !== null) {
            queryParameters = queryParameters.set('contrintegperc.notEquals', <any>contrintegpercNotEquals);
        }
        if (contrintegpercSpecified !== undefined && contrintegpercSpecified !== null) {
            queryParameters = queryParameters.set('contrintegperc.specified', <any>contrintegpercSpecified);
        }
        if (contrintegvalEquals !== undefined && contrintegvalEquals !== null) {
            queryParameters = queryParameters.set('contrintegval.equals', <any>contrintegvalEquals);
        }
        if (contrintegvalGreaterThan !== undefined && contrintegvalGreaterThan !== null) {
            queryParameters = queryParameters.set('contrintegval.greaterThan', <any>contrintegvalGreaterThan);
        }
        if (contrintegvalGreaterThanOrEqual !== undefined && contrintegvalGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegval.greaterThanOrEqual', <any>contrintegvalGreaterThanOrEqual);
        }
        if (contrintegvalIn) {
            contrintegvalIn.forEach((element) => {
                queryParameters = queryParameters.append('contrintegval.in', <any>element);
            })
        }
        if (contrintegvalLessThan !== undefined && contrintegvalLessThan !== null) {
            queryParameters = queryParameters.set('contrintegval.lessThan', <any>contrintegvalLessThan);
        }
        if (contrintegvalLessThanOrEqual !== undefined && contrintegvalLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('contrintegval.lessThanOrEqual', <any>contrintegvalLessThanOrEqual);
        }
        if (contrintegvalNotEquals !== undefined && contrintegvalNotEquals !== null) {
            queryParameters = queryParameters.set('contrintegval.notEquals', <any>contrintegvalNotEquals);
        }
        if (contrintegvalSpecified !== undefined && contrintegvalSpecified !== null) {
            queryParameters = queryParameters.set('contrintegval.specified', <any>contrintegvalSpecified);
        }
        if (descrizioneContains !== undefined && descrizioneContains !== null) {
            queryParameters = queryParameters.set('descrizione.contains', <any>descrizioneContains);
        }
        if (descrizioneDoesNotContain !== undefined && descrizioneDoesNotContain !== null) {
            queryParameters = queryParameters.set('descrizione.doesNotContain', <any>descrizioneDoesNotContain);
        }
        if (descrizioneEquals !== undefined && descrizioneEquals !== null) {
            queryParameters = queryParameters.set('descrizione.equals', <any>descrizioneEquals);
        }
        if (descrizioneIn) {
            descrizioneIn.forEach((element) => {
                queryParameters = queryParameters.append('descrizione.in', <any>element);
            })
        }
        if (descrizioneNotEquals !== undefined && descrizioneNotEquals !== null) {
            queryParameters = queryParameters.set('descrizione.notEquals', <any>descrizioneNotEquals);
        }
        if (descrizioneSpecified !== undefined && descrizioneSpecified !== null) {
            queryParameters = queryParameters.set('descrizione.specified', <any>descrizioneSpecified);
        }
        if (idEquals !== undefined && idEquals !== null) {
            queryParameters = queryParameters.set('id.equals', <any>idEquals);
        }
        if (idGreaterThan !== undefined && idGreaterThan !== null) {
            queryParameters = queryParameters.set('id.greaterThan', <any>idGreaterThan);
        }
        if (idGreaterThanOrEqual !== undefined && idGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.greaterThanOrEqual', <any>idGreaterThanOrEqual);
        }
        if (idIn) {
            idIn.forEach((element) => {
                queryParameters = queryParameters.append('id.in', <any>element);
            })
        }
        if (idLessThan !== undefined && idLessThan !== null) {
            queryParameters = queryParameters.set('id.lessThan', <any>idLessThan);
        }
        if (idLessThanOrEqual !== undefined && idLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('id.lessThanOrEqual', <any>idLessThanOrEqual);
        }
        if (idNotEquals !== undefined && idNotEquals !== null) {
            queryParameters = queryParameters.set('id.notEquals', <any>idNotEquals);
        }
        if (idSpecified !== undefined && idSpecified !== null) {
            queryParameters = queryParameters.set('id.specified', <any>idSpecified);
        }
        if (idarticoloEquals !== undefined && idarticoloEquals !== null) {
            queryParameters = queryParameters.set('idarticolo.equals', <any>idarticoloEquals);
        }
        if (idarticoloGreaterThan !== undefined && idarticoloGreaterThan !== null) {
            queryParameters = queryParameters.set('idarticolo.greaterThan', <any>idarticoloGreaterThan);
        }
        if (idarticoloGreaterThanOrEqual !== undefined && idarticoloGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('idarticolo.greaterThanOrEqual', <any>idarticoloGreaterThanOrEqual);
        }
        if (idarticoloIn) {
            idarticoloIn.forEach((element) => {
                queryParameters = queryParameters.append('idarticolo.in', <any>element);
            })
        }
        if (idarticoloLessThan !== undefined && idarticoloLessThan !== null) {
            queryParameters = queryParameters.set('idarticolo.lessThan', <any>idarticoloLessThan);
        }
        if (idarticoloLessThanOrEqual !== undefined && idarticoloLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('idarticolo.lessThanOrEqual', <any>idarticoloLessThanOrEqual);
        }
        if (idarticoloNotEquals !== undefined && idarticoloNotEquals !== null) {
            queryParameters = queryParameters.set('idarticolo.notEquals', <any>idarticoloNotEquals);
        }
        if (idarticoloSpecified !== undefined && idarticoloSpecified !== null) {
            queryParameters = queryParameters.set('idarticolo.specified', <any>idarticoloSpecified);
        }
        if (iddettfatturaEquals !== undefined && iddettfatturaEquals !== null) {
            queryParameters = queryParameters.set('iddettfattura.equals', <any>iddettfatturaEquals);
        }
        if (iddettfatturaGreaterThan !== undefined && iddettfatturaGreaterThan !== null) {
            queryParameters = queryParameters.set('iddettfattura.greaterThan', <any>iddettfatturaGreaterThan);
        }
        if (iddettfatturaGreaterThanOrEqual !== undefined && iddettfatturaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('iddettfattura.greaterThanOrEqual', <any>iddettfatturaGreaterThanOrEqual);
        }
        if (iddettfatturaIn) {
            iddettfatturaIn.forEach((element) => {
                queryParameters = queryParameters.append('iddettfattura.in', <any>element);
            })
        }
        if (iddettfatturaLessThan !== undefined && iddettfatturaLessThan !== null) {
            queryParameters = queryParameters.set('iddettfattura.lessThan', <any>iddettfatturaLessThan);
        }
        if (iddettfatturaLessThanOrEqual !== undefined && iddettfatturaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('iddettfattura.lessThanOrEqual', <any>iddettfatturaLessThanOrEqual);
        }
        if (iddettfatturaNotEquals !== undefined && iddettfatturaNotEquals !== null) {
            queryParameters = queryParameters.set('iddettfattura.notEquals', <any>iddettfatturaNotEquals);
        }
        if (iddettfatturaSpecified !== undefined && iddettfatturaSpecified !== null) {
            queryParameters = queryParameters.set('iddettfattura.specified', <any>iddettfatturaSpecified);
        }
        if (iddocEquals !== undefined && iddocEquals !== null) {
            queryParameters = queryParameters.set('iddoc.equals', <any>iddocEquals);
        }
        if (iddocGreaterThan !== undefined && iddocGreaterThan !== null) {
            queryParameters = queryParameters.set('iddoc.greaterThan', <any>iddocGreaterThan);
        }
        if (iddocGreaterThanOrEqual !== undefined && iddocGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('iddoc.greaterThanOrEqual', <any>iddocGreaterThanOrEqual);
        }
        if (iddocIn) {
            iddocIn.forEach((element) => {
                queryParameters = queryParameters.append('iddoc.in', <any>element);
            })
        }
        if (iddocLessThan !== undefined && iddocLessThan !== null) {
            queryParameters = queryParameters.set('iddoc.lessThan', <any>iddocLessThan);
        }
        if (iddocLessThanOrEqual !== undefined && iddocLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('iddoc.lessThanOrEqual', <any>iddocLessThanOrEqual);
        }
        if (iddocNotEquals !== undefined && iddocNotEquals !== null) {
            queryParameters = queryParameters.set('iddoc.notEquals', <any>iddocNotEquals);
        }
        if (iddocSpecified !== undefined && iddocSpecified !== null) {
            queryParameters = queryParameters.set('iddoc.specified', <any>iddocSpecified);
        }
        if (importoEquals !== undefined && importoEquals !== null) {
            queryParameters = queryParameters.set('importo.equals', <any>importoEquals);
        }
        if (importoGreaterThan !== undefined && importoGreaterThan !== null) {
            queryParameters = queryParameters.set('importo.greaterThan', <any>importoGreaterThan);
        }
        if (importoGreaterThanOrEqual !== undefined && importoGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('importo.greaterThanOrEqual', <any>importoGreaterThanOrEqual);
        }
        if (importoIn) {
            importoIn.forEach((element) => {
                queryParameters = queryParameters.append('importo.in', <any>element);
            })
        }
        if (importoLessThan !== undefined && importoLessThan !== null) {
            queryParameters = queryParameters.set('importo.lessThan', <any>importoLessThan);
        }
        if (importoLessThanOrEqual !== undefined && importoLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('importo.lessThanOrEqual', <any>importoLessThanOrEqual);
        }
        if (importoNotEquals !== undefined && importoNotEquals !== null) {
            queryParameters = queryParameters.set('importo.notEquals', <any>importoNotEquals);
        }
        if (importoSpecified !== undefined && importoSpecified !== null) {
            queryParameters = queryParameters.set('importo.specified', <any>importoSpecified);
        }
        if (ivaEquals !== undefined && ivaEquals !== null) {
            queryParameters = queryParameters.set('iva.equals', <any>ivaEquals);
        }
        if (ivaGreaterThan !== undefined && ivaGreaterThan !== null) {
            queryParameters = queryParameters.set('iva.greaterThan', <any>ivaGreaterThan);
        }
        if (ivaGreaterThanOrEqual !== undefined && ivaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('iva.greaterThanOrEqual', <any>ivaGreaterThanOrEqual);
        }
        if (ivaIn) {
            ivaIn.forEach((element) => {
                queryParameters = queryParameters.append('iva.in', <any>element);
            })
        }
        if (ivaLessThan !== undefined && ivaLessThan !== null) {
            queryParameters = queryParameters.set('iva.lessThan', <any>ivaLessThan);
        }
        if (ivaLessThanOrEqual !== undefined && ivaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('iva.lessThanOrEqual', <any>ivaLessThanOrEqual);
        }
        if (ivaNotEquals !== undefined && ivaNotEquals !== null) {
            queryParameters = queryParameters.set('iva.notEquals', <any>ivaNotEquals);
        }
        if (ivaSpecified !== undefined && ivaSpecified !== null) {
            queryParameters = queryParameters.set('iva.specified', <any>ivaSpecified);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (prezzoEquals !== undefined && prezzoEquals !== null) {
            queryParameters = queryParameters.set('prezzo.equals', <any>prezzoEquals);
        }
        if (prezzoGreaterThan !== undefined && prezzoGreaterThan !== null) {
            queryParameters = queryParameters.set('prezzo.greaterThan', <any>prezzoGreaterThan);
        }
        if (prezzoGreaterThanOrEqual !== undefined && prezzoGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('prezzo.greaterThanOrEqual', <any>prezzoGreaterThanOrEqual);
        }
        if (prezzoIn) {
            prezzoIn.forEach((element) => {
                queryParameters = queryParameters.append('prezzo.in', <any>element);
            })
        }
        if (prezzoLessThan !== undefined && prezzoLessThan !== null) {
            queryParameters = queryParameters.set('prezzo.lessThan', <any>prezzoLessThan);
        }
        if (prezzoLessThanOrEqual !== undefined && prezzoLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('prezzo.lessThanOrEqual', <any>prezzoLessThanOrEqual);
        }
        if (prezzoNotEquals !== undefined && prezzoNotEquals !== null) {
            queryParameters = queryParameters.set('prezzo.notEquals', <any>prezzoNotEquals);
        }
        if (prezzoSpecified !== undefined && prezzoSpecified !== null) {
            queryParameters = queryParameters.set('prezzo.specified', <any>prezzoSpecified);
        }
        if (qtaEquals !== undefined && qtaEquals !== null) {
            queryParameters = queryParameters.set('qta.equals', <any>qtaEquals);
        }
        if (qtaGreaterThan !== undefined && qtaGreaterThan !== null) {
            queryParameters = queryParameters.set('qta.greaterThan', <any>qtaGreaterThan);
        }
        if (qtaGreaterThanOrEqual !== undefined && qtaGreaterThanOrEqual !== null) {
            queryParameters = queryParameters.set('qta.greaterThanOrEqual', <any>qtaGreaterThanOrEqual);
        }
        if (qtaIn) {
            qtaIn.forEach((element) => {
                queryParameters = queryParameters.append('qta.in', <any>element);
            })
        }
        if (qtaLessThan !== undefined && qtaLessThan !== null) {
            queryParameters = queryParameters.set('qta.lessThan', <any>qtaLessThan);
        }
        if (qtaLessThanOrEqual !== undefined && qtaLessThanOrEqual !== null) {
            queryParameters = queryParameters.set('qta.lessThanOrEqual', <any>qtaLessThanOrEqual);
        }
        if (qtaNotEquals !== undefined && qtaNotEquals !== null) {
            queryParameters = queryParameters.set('qta.notEquals', <any>qtaNotEquals);
        }
        if (qtaSpecified !== undefined && qtaSpecified !== null) {
            queryParameters = queryParameters.set('qta.specified', <any>qtaSpecified);
        }
        if (size !== undefined && size !== null) {
            queryParameters = queryParameters.set('size', <any>size);
        }
        if (sort) {
            sort.forEach((element) => {
                queryParameters = queryParameters.append('sort', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ApolloDocumentLineDTO>>('get',`${this.basePath}/api/apollo-document-lines`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getApolloDocumentLine
     * 
     * @param id id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getApolloDocumentLineUsingGET(id: number, observe?: 'body', reportProgress?: boolean): Observable<ApolloDocumentLineDTO>;
    public getApolloDocumentLineUsingGET(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApolloDocumentLineDTO>>;
    public getApolloDocumentLineUsingGET(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApolloDocumentLineDTO>>;
    public getApolloDocumentLineUsingGET(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getApolloDocumentLineUsingGET.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ApolloDocumentLineDTO>('get',`${this.basePath}/api/apollo-document-lines/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateApolloDocumentLine
     * 
     * @param body apolloDocumentLineDTO
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateApolloDocumentLineUsingPUT(body: ApolloDocumentLineDTO, observe?: 'body', reportProgress?: boolean): Observable<ApolloDocumentLineDTO>;
    public updateApolloDocumentLineUsingPUT(body: ApolloDocumentLineDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApolloDocumentLineDTO>>;
    public updateApolloDocumentLineUsingPUT(body: ApolloDocumentLineDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApolloDocumentLineDTO>>;
    public updateApolloDocumentLineUsingPUT(body: ApolloDocumentLineDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateApolloDocumentLineUsingPUT.');
        }

        let headers = this.defaultHeaders;

        // authentication (ServiceAccount) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // authentication (UserInterface) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ApolloDocumentLineDTO>('put',`${this.basePath}/api/apollo-document-lines`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
